import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { LoaderService } from '@teem/services/loader.service';
import { SharedDataService } from '@teem/services/shared-data.service';
import { UserService } from '@teem/services/user.service';
import { messages as i18n } from '@teem/constants/messages';

@Component({
	selector: 'opay-tab',
	templateUrl: './opay-tab.component.html',
	styleUrls: []
})
export class OpayTabComponent implements OnInit {
	@Output() public updateUserDetails = new EventEmitter();
	@Output() public goToPlan = new EventEmitter();
	submitted: boolean = false;
	userDetails: any = null;
	labelStatus: string = 'default_show';
	merchantForm: FormGroup;

	constructor(
		private fb: FormBuilder,
		private loaderService: LoaderService,
		private userService: UserService,
		private sharedDataService: SharedDataService
	) { }

	ngOnInit(): void {
		this.merchantForm = this.fb.group({
			opay_public_key: [this.userDetails ? this.userDetails?.payment_model?.opay_public_key : '', Validators.required],
			opay_secret_key: [this.userDetails ? this.userDetails?.payment_model?.opay_secret_key : '', Validators.required],
			opay_merchant_id: [this.userDetails ? this.userDetails?.payment_model?.opay_merchant_id : '', Validators.required],
		});
	}

	@Input('userDetails')
	set setUserDetails(val: any) {
		if (val) {
			this.userDetails = val;
			if (this.merchantForm) {
				this.merchantForm.get('opay_public_key').setValue(val?.payment_model?.opay_public_key);
				this.merchantForm.get('opay_secret_key').setValue(val?.payment_model?.opay_secret_key);
				this.merchantForm.get('opay_merchant_id').setValue(val?.payment_model?.opay_merchant_id);
			}
		} else {
			if (this.merchantForm) {
				this.merchantForm.get('opay_public_key').setValue('');
				this.merchantForm.get('opay_secret_key').setValue('');
				this.merchantForm.get('opay_merchant_id').setValue('');
			}
		}

		if (this.userDetails?.subscription.subscription_status == 'free') {
			this.labelStatus = 'free_user';
		} else {
			this.labelStatus = 'paid_user';
		}
	}

	get f() {
		return this.merchantForm.controls;
	}

	onSubmit(form: FormGroup) {
		this.submitted = true;
		if (form.valid) {
			this.loaderService.startLoading();
			this.userService.addMerchantInfo('opay', form.value).subscribe(
				(res: any) => {
					this.loaderService.stopLoading();

					// Update parent user
					this.userDetails = res.user;
					this.updateUserDetails.emit(this.userDetails);

					// Update app basic info for user
					let userInfo = this.sharedDataService.getItem('userInfo');
					if (userInfo != undefined) {
						userInfo = this.userDetails;
						this.sharedDataService.setItem('userInfo', userInfo);
					}

					Swal.fire(i18n.done, 'Thank you for entering your details', 'success');
				},
				(err) => {
					this.loaderService.stopLoading();
					if (err.status === 422) {
						if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
							let validationErrors = err.error.errors;
							Object.keys(validationErrors).forEach((prop) => {
								this.merchantForm.get(prop)?.setErrors({
									serverError: validationErrors[prop]
								})
							})
						}
					}
					Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
				}
			)
		}
	}

	deleteMerchant() {
		this.submitted = false;
		Swal.fire({
			title: i18n.are_you_sure,
			text: i18n.setting.remove_paypal_merchant_confirm,
			icon: 'info',
			showCloseButton: true,
			showCancelButton: true,
			focusConfirm: false,
			confirmButtonText: i18n.yes,
			cancelButtonText: i18n.no_cancel_it
		}).then((result: any) => {
			if (result.value) {
				this.loaderService.startLoading();
				this.userService.removeMerchant('opay').subscribe((data: any) => {
					this.loaderService.stopLoading();
					this.merchantForm.get('opay_public_key').setValue('');
					this.merchantForm.get('opay_secret_key').setValue('');
					this.merchantForm.get('opay_merchant_id').setValue('');

					// Update parent user
					this.userDetails.payment_model.opay_public_key = null;
					this.userDetails.payment_model.opay_secret_key = null;
					this.userDetails.payment_model.opay_merchant_id = null;
					this.userDetails.accept_opay_payment = 0;
					this.updateUserDetails.emit(this.userDetails);

					// Update app basic info for user
					let userInfo = this.sharedDataService.getItem('userInfo');
					if (userInfo != undefined) {
						userInfo.payment_model.opay_public_key = null;
						userInfo.payment_model.opay_secret_key = null;
						userInfo.payment_model.opay_merchant_id = null;
						userInfo.accept_opay_payment = 0;
						this.sharedDataService.setItem('userInfo', userInfo);
					}

					setTimeout(function () {
						Swal.fire(i18n.done, i18n.setting.remove_paypal_merchant_success, 'success');
					}, 0);
				}, err => {
					this.loaderService.stopLoading();
					Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
				})
			} else {
				return false;
			}
		});
	}

}
